module.exports = __webpack_public_path__ + "img/home-covid1.63b025f4.jpg";